var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BBDF7",
    d: "M10.174 11.272 12 15.254l2.713-1.542h.005v-3.085l-4.544.645Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2891F9",
    d: "m18.22 8.314-1.692-.627-1.81-.145v9.613l2.715 1.543 2.166-4.346-1.373-4.181-.005-1.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BBDF7",
    d: "m18.063 7.542-.63 1.543v9.59l2.716-1.544V7.54h-2.086Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6DEF",
    d: "m17.433 6-2.716 1.542 2.716 1.543 2.716-1.543L17.433 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2891F9",
    d: "M12 12.169 9.284 9.172l-5.433-1.63v9.589l2.715 1.543.78-5.307 1.938.345L12 15.254V12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6DEF",
    d: "M6.566 6 3.851 7.542 12 12.169l1.231-.697 1.487-.845L6.566 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BBDF7",
    d: "M6.567 12.169v6.505l2.717-1.543v-3.419L6.567 12.17Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.1b32bb5d4a2d187c68378117a216afff.svg";
export { ForwardRef as ReactComponent };